import React from 'react';
import { LayoutPage } from 'components/layouts';
import { Alert } from 'antd';
import { Form, FormItem, InputNumber, Select, Slider } from 'formik-antd';
import { Formik } from 'formik';
import { simpleFilterOptions } from 'utils/form';
// import { commuteOptions } from 'utils/shifts';
import { timeOptions } from 'utils/dates';
import { Fieldset } from 'components/form';
import { RolesBySector, sectors } from 'utils/roles-sectors';
import Qualifications from 'utils/qualifications';
import mandatoryCourses from 'utils/mandatory-courses';
import WorkerSearchResults from '../worker-search-results';
import './style.css';

const WorkerSearch = () => {
  const initialValues = {
    sector: null,
    role: null,
    qualifications: null,
    trainingCourses: null,
    rate: 50,
    shiftTimes: null,
  };

  const fieldStyle = { padding: '2px' };

  return (
    <LayoutPage className="worker-search-page">
      <LayoutPage.Container>
        <Formik initialValues={initialValues}>
          {({ values, status, setStatus, setFieldValue }) => {
            const roles = values.sector ? RolesBySector(values.sector) : [];
            return (
              <Form layout="vertical" className="wrapper">
                <section className="worker-search-filter-form">
                  <h1>Search for workers</h1>
                  {status != null ? (
                    <Alert
                      closable
                      message={status.message}
                      type={status.type}
                      onClose={() => {
                        setStatus(undefined);
                      }}
                    />
                  ) : null}

                  <Fieldset>
                    <FormItem label="Sector" name="sector">
                      <Select
                        name="sector"
                        placeholder="Please select a sector"
                        optionFilterProp="children"
                        filterOption={simpleFilterOptions}
                        showSearch
                        allowClear
                        onChange={() => {
                          setFieldValue('role', null);
                        }}
                      >
                        {sectors.map(({ name, label }) => (
                          <Select.Option value={name} key={name}>
                            {label}
                          </Select.Option>
                        ))}
                      </Select>
                    </FormItem>

                    <FormItem label="Role" name="role">
                      <Select
                        disabled={values.sector == null}
                        name="role"
                        placeholder="Please select a role option"
                        optionFilterProp="children"
                        filterOption={simpleFilterOptions}
                        showSearch
                        allowClear
                      >
                        {roles.map(({ name, label }) => (
                          <Select.Option value={name} key={name}>
                            {label}
                          </Select.Option>
                        ))}
                      </Select>
                    </FormItem>
                  </Fieldset>

                  <Fieldset>
                    <FormItem label="Qualifications" name="qualifications">
                      <Select
                        name="qualifications"
                        placeholder="Please select a qualification"
                        optionFilterProp="children"
                        filterOption={simpleFilterOptions}
                        mode="multiple"
                        showSearch
                        allowClear
                      >
                        {Qualifications.map(({ name, label }) => (
                          <Select.Option value={name} key={name}>
                            {label}
                          </Select.Option>
                        ))}
                      </Select>
                    </FormItem>

                    <FormItem label="Training Courses" name="trainingCourses">
                      <Select
                        name="trainingCourses"
                        placeholder="Please select courses"
                        optionFilterProp="children"
                        filterOption={simpleFilterOptions}
                        mode="multiple"
                        showSearch
                        allowClear
                      >
                        {mandatoryCourses.map(({ name, label }) => (
                          <Select.Option value={name} key={name}>
                            {label}
                          </Select.Option>
                        ))}
                      </Select>
                    </FormItem>
                  </Fieldset>

                  <Fieldset>
                    <FormItem
                      className="hour-rate"
                      label="Hour rate"
                      name="rate"
                    >
                      <Slider
                        name="rate"
                        min={10}
                        max={100}
                        step={1}
                        tipFormatter={(v) => `£${v}`}
                        tooltipPlacement="bottom"
                      />
                      <InputNumber
                        name="rate"
                        min={10}
                        max={100}
                        style={fieldStyle}
                      />
                    </FormItem>

                    <FormItem name="shiftTimes" label="Shift Time">
                      <Select
                        name="shiftTimes"
                        placeholder="Shift Time"
                        optionFilterProp="children"
                        filterOption={simpleFilterOptions}
                        mode="multiple"
                        showSearch
                        allowClear
                      >
                        {timeOptions.map(({ startTime, endTime }, idx) => (
                          <Select.Option value={idx} key={idx}>
                            {`${startTime} - ${endTime}`}
                          </Select.Option>
                        ))}
                      </Select>
                    </FormItem>
                  </Fieldset>
                </section>

                <WorkerSearchResults values={values} />
              </Form>
            );
          }}
        </Formik>
      </LayoutPage.Container>
    </LayoutPage>
  );
};

export default WorkerSearch;
